export default "__VITE_ASSET__4ec8b988__"